import React from 'react';
import PropTypes from 'prop-types';
import { get, isEqual } from 'lodash';
import chroma from "chroma-js";

function TollRoutes(RouteComponent) {
  return class Route extends React.Component {
    static propTypes = {
      options: PropTypes.object,
      result: PropTypes.object,
      colorPalette: PropTypes.object,
      tabIndex: PropTypes.number.isRequired,
      refClient: PropTypes.object.isRequired,
    };
    state = {};

    shouldComponentUpdate(nextProps) {
      const {
        options: { selectedPath },
        options,
      } = this.props;
      const selectedRoute = get(this.props, selectedPath, 0);
      const { routesArrayPath } = options;
      const nextSelectedRoute = get(nextProps, selectedPath, 0);
      const routes = get(this.props, routesArrayPath);
      const nextRoutes = get(nextProps, routesArrayPath);
      return selectedRoute !== nextSelectedRoute || isEqual(routes, nextRoutes);
    }

    renderRoutes = (
      tollRoutes,
      tollSystemsList,
      tollRouteSystems,
      colorPalette
    ) => {
      const tollSystemsExclude = get(this.props, 'result.state.tollSystemsRoadExclude', '').split(',');
      const colorScale = chroma.scale([colorPalette.primary, 'black']).mode('lch').colors(tollRouteSystems.length+2);
      const result = [];
      tollRoutes.forEach((tollRoute, i) => {
        const { tollSystem, route } = tollRoute;
        const names = tollSystem.split(':').map(id => tollSystemsList[id].name).sort();
    
        if (!tollSystemsExclude.includes(names.join('-'))) {
          result.push(<RouteComponent
            key={`tollRoute-${i}`}
            positions={route.shape}
            color={colorScale[tollRouteSystems.indexOf(tollSystem)+1]}
            weight={8}
            zIndex={31}
          />)
        }
      });
      return result;
    };

    render() {
      const {
        result,
        options,
        colorPalette,
        refClient: { formatterPlugin },
      } = this.props;
      const {
        routesArrayPath,
        formatter,
      } = options;

      const isTollsActive = get(result, 'state.isTollsActive');
      const showTollroad = get(result, 'state.showTollroad', true);
      const routes = get(this.props, routesArrayPath);

      if (routes && isTollsActive && showTollroad) {
        const maneuversFormatter = formatterPlugin.get(formatter);

        const currentRoute = get(result, 'state.currentRoute') || 0;
        const route = get(result, ['raw', 'data', 'routes', currentRoute]);
        const maneuvers = maneuversFormatter(route);
        const tollRoutes = [];
        const tollSystemsList = [];
        const tollRouteSystems = [];

        maneuvers.sections && maneuvers.sections.forEach(({ spans: maneuverSpans, id }) => {
          const { tollSystems = [], spans = [] } = route.sections[id];

          tollSystemsList.push(...tollSystems.filter(tollSystem =>
            !tollSystemsList.some(thisTollSystem => thisTollSystem.name === tollSystem.name && thisTollSystem.id === tollSystem.id)
          ));

          spans.forEach((span, spanIdx) => {
            const tollSystemsSpan = span.tollSystems;
            if (tollSystemsSpan) {
              const idx = tollSystemsSpan.map(i => {
                const tollSystem = tollSystems[i];
                return tollSystemsList.findIndex(thisTollSystem => thisTollSystem.name === tollSystem.name && thisTollSystem.id === tollSystem.id )
              }).join(':');
              tollRoutes.push({
                route: maneuverSpans[spanIdx],
                tollSystem: idx
              });
              if (!tollRouteSystems.includes(idx)) {
                tollRouteSystems.push(idx);
              }
            }
          })
        })

        return (
          <>
            {this.renderRoutes(
              tollRoutes,
              tollSystemsList,
              tollRouteSystems,
              colorPalette
            )}
          </>
        );
      } else {
        return null;
      }
    }
  };
}

export default TollRoutes;
